import Evented from '@ember/object/evented';
import Service from '@ember/service';
import { assert } from '@ember/debug';

export const INSERT_LIQUID = 'insertLiquid';
export const INSERT_LIQUID_WITH_FALLBACK_MODAL_OPEN = 'insertLiquidWithFallbackModal:open';
export const INSERT_LIQUID_WITH_FALLBACK_MODAL_CLOSE = 'insertLiquidWithFallbackModal:close';
export const LIQUID_ENABLED_FIELD_FOCUS_IN = 'liquidEnabledField:focus-in';
export const LIQUID_ENABLED_FIELD_FOCUS_OUT = 'liquidEnabledField:focus-out';
export const EMAIL_COMPOSER_ROLLBACK = 'emailComposer:rollback';
export const CONFIRM_TRANSITION = 'confirmTransition';
export const BEE_INSERT_LIQUID = 'beeInsertLiquid';
export const ENVIRONMENT_RELOAD = 'environment:reload';
export const MAIN_NAV_EXPAND = 'mainNav:expand';
export const MAIN_NAV_COLLAPSE = 'mainNav:collapse';
export const VWB_ACTION_UPDATED = 'vwb:action-updated';
export const VWB_ACTION_STATE_CHANGED = 'vwb:action-state-changed';
export const VWB_RESET_COPY_TO = 'vwb:reset-copy-to';
export const VWB_CONFIRM_SINGLE_MOVE = 'vwb:confirm-single-move';
export const VWB_CONFIRM_BULK_MOVE = 'vwb:confirm-bulk-move';
export const VWB_CANCEL_MOVE = 'vwb:cancel-move';
export const VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT = 'vwb:initiate-single-shortcut-delete';
export const VWB_BEFORE_ACTION_ADD_MOVE_OR_DELETE = 'vwb:before-action-add-move-or-delete';
export const CUSTOMER_ATTRIBUTES_UPDATED = 'customer:attributes-updated';
export const FOCUS_ACE_EDITOR = 'focusAceEditor';

export default class EventBusService extends Service.extend(Evented) {
  publish(event: string, ...args: unknown[]) {
    this.trigger(event, ...args);
  }

  subscribe(event: string, target: Record<string, any>, callback: (...args: any[]) => unknown) {
    assert('event must be a string', typeof event === 'string');
    assert('target must be an object', typeof target === 'object');
    assert('callback must be a function', typeof callback === 'function');

    this.on(event, target, callback);
  }

  unsubscribe(event: string, target: Record<string, any>, callback: (...args: any[]) => unknown) {
    assert('event must be a string', typeof event === 'string');
    assert('target must be an object', typeof target === 'object');
    assert('callback must be a function', typeof callback === 'function');

    this.off(event, target, callback);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'event-bus': EventBusService;
  }
}
